import { z } from 'zod';

// Paginated read of an itinerary version's customer-preview view log
// ("Viewed Times Logs" modal). `limit`/`offset` mirror the legacy `find`
// (default page size 10).
export const findViewedTimesLogInput = z.object({
  itineraryVersionId: z.uuid(),
  limit: z.number().int().min(1).max(100).default(10),
  offset: z.number().int().min(0).default(0),
});
export type FindViewedTimesLogInput = z.infer<typeof findViewedTimesLogInput>;

// One recorded view. `ip` is already masked at write time; `country` is the
// resolved display name ('' when unknown); `browser` is the raw user-agent.
// `createdOn` is a naked UTC Postgres timestamp string (parse with UTCDate).
export const viewedTimesLogItem = z.object({
  id: z.string(),
  createdOn: z.string(),
  country: z.string().nullable(),
  ip: z.string().nullable(),
  browser: z.string().nullable(),
});
export type ViewedTimesLogItem = z.infer<typeof viewedTimesLogItem>;

export const findViewedTimesLogResult = z.object({
  data: z.array(viewedTimesLogItem),
  total: z.number().int(),
});
export type FindViewedTimesLogResult = z.infer<typeof findViewedTimesLogResult>;
